import React from "react";
import { Box, Chip, IconButton, Tooltip } from "@mui/material";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { AccountsandFinanceurl, AssetFinanceUrl } from "../../../../config";
import DynamicTableForJson from "../../../../data/DynamicTable/dynamicTableForJson";
import ManualLoanRepaymentForm from "./form";

const base_url = AssetFinanceUrl.uri;

const formatCurrency = (value) => {
  if (value === null || value === undefined || value === "") return "-";
  return `KES ${Number(value).toLocaleString(undefined, { maximumFractionDigits: 2 })}`;
};

const rightsTourSteps = [
  {
    target: ".dynamic-table-header",
    content: "This is the Manual Loan Repayment page, where you can post a manual payment against a customer's loan for a checker to approve.",
    placement: "top",
    disableBeacon: true,
  },
  {
    target: ".dynamic-table-add-button",
    content: "Click this button to search for a customer and post a new manual repayment.",
    placement: "right",
  },
  {
    target: ".dynamic-table-actions",
    content: "Approve or reject a pending manual payment from this dropdown.",
    placement: "left",
  },
];

const columns = [
  { field: "ManualPaymentId", headerName: "Payment ID", width: 100 },
  { field: "CustomerName", headerName: "Customer", flex: 1 },
  { field: "CustomerPhone", headerName: "Phone", flex: 1 },
  { field: "LoanId", headerName: "Loan ID", width: 100 },
  {
    field: "CurrentLoanBalance",
    headerName: "Loan Balance",
    flex: 1,
    valueGetter: (params) => formatCurrency(params.row.CurrentLoanBalance),
  },
  {
    field: "Amount",
    headerName: "Amount",
    flex: 1,
    valueGetter: (params) => formatCurrency(params.row.Amount),
  },
  { field: "Narration", headerName: "Narration", flex: 1 },
  { field: "MakerName", headerName: "Posted By", flex: 1 },
  { field: "DateCreated", headerName: "Date Posted", flex: 1 },
  {
    field: "DaysPending",
    headerName: "Days Pending",
    width: 130,
    renderCell: (params) => {
      const days = params.row.DaysPending ?? 0;
      return (
        <Chip
          label={days}
          size="small"
          color={days >= 3 ? "error" : days >= 1 ? "warning" : "default"}
          sx={{ fontWeight: 600, fontSize: "0.7rem" }}
        />
      );
    },
  },
  {
    field: "PaymentSlipUrl",
    headerName: "Payment Slip",
    width: 120,
    sortable: false,
    renderCell: (params) => {
      const url = params.row.PaymentSlipUrl;
      if (!url) return <span style={{ color: "#aaa", fontSize: "0.75rem" }}>—</span>;
      return (
        <Tooltip title="View payment slip">
          <IconButton
            size="small"
            color="primary"
            onClick={() => window.open(url, "_blank", "noopener,noreferrer")}
          >
            <OpenInNewIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      );
    },
  },
];

const ManualLoanRepaymentTable = () => {
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const companyId = parseInt(decodedToken.CompanyId);

  const actions = {
    entity: localStorage.getItem("SelectedRight"),
    add: {
      key: "ADD",
      button_name: "New Manual Payment",
      Show_Button: true,
      permission: "CreatePermission",
    },
    ApproveManualPayment: {
      key: "APPROVE",
      button_name: "Approve",
      Show_Button: true,
      permission: "ActivatePermission",
    },
    RejectManualPayment: {
      key: "REJECT",
      button_name: "Reject",
      Show_Button: true,
      permission: "ActivatePermission",
    },
    dataObject: {
      ignoreFields: ["CustomerId", "CompanyId", "BranchId", "MakerId", "ReceiptNumber", "ReceiptDate", "PaymentSlipObjectName"],
      objectName: "pendingManualPaymentsByColumnValues",
      parameters: { companyId },
      inputObjectName: "pendingPayment",
    },
    showStatus: true
  };

  return (
    <Box m="20px">
      <DynamicTableForJson
        title="Manual Loan Repayment"
        subtitle="Post manual loan repayments and approve those pending review"
        FormComponent={ManualLoanRepaymentForm}
        columns={columns}
        base_url={base_url}
        actions={actions}
        tourSteps={rightsTourSteps}
      />
    </Box>
  );
};

export default ManualLoanRepaymentTable;
